// camera-controller.js
var CameraController = pc.createScript('cameraController');

CameraController.attributes.add('secsIdleAutoOrbit', {type: 'number', default: 2, title: 'Secs Idle Auto Orbit', });
CameraController.attributes.add('autoOrbitSpeed', {type: 'number', default: 2, title: 'Auto orbit speed', });
CameraController.attributes.add('autoOrbitPitch', {type: 'number', default: 2, title: 'Auto orbit pitch', });
CameraController.attributes.add('autoOrbitDistance', {type: 'number', default: 2, title: 'Auto orbit distance',});
CameraController.attributes.add('noPlanets', {type:'boolean', default:false});


Object.defineProperty(CameraController.prototype, "distance", {
    get: function() {
        return this.orbitCamera.distance;
    },

    set: function(value) {
        this.orbitCamera.distance = value;
        this.secsSinceUserInput = 0;
    }
});


Object.defineProperty(CameraController.prototype, "pitch", {
    get: function() {
        return this.orbitCamera.pitch;
    },

    set: function(value) {
        this.orbitCamera.pitch = value;
        this.secsSinceUserInput = 0;
    }
});


// Property to get and set the yaw of the camera around the pivot point (degrees)
Object.defineProperty(CameraController.prototype, "yaw", {
    get: function() {
        return this.orbitCamera.yaw;
    },

    set: function(value) {
        this.orbitCamera.yaw = value;
        this.secsSinceUserInput = 0;
    }
});


CameraController.prototype.initialize = function() {


    this.isActive = false;
    this.orbitCamera = this.entity.script.orbitCamera;
    this.secsSinceUserInput = 0;
    this.app.on('cameraController:autoOrbit', this.startOrbit, this);
    this.app.on('cameraController:autoOrbitSystems', this.autoOrbitSystems, this);
    this.app.on('solarSystem:planetList', this.getPlanets, this);
    this.app.on('cameraController:haltRotation', this.haltSequence, this);
    this.app.on('userInput:objectSelected', this.getNumber, this);
    this.app.once('systemGenerator:reset', this.resetSeq, this);
    this.startAutoOrbit = false;
    this.planets = [];
    this.sun = null;
    this.planetCounter = 0;
    this.dummy = this.app.root.findByName('tweenDummy');
    this.camScript = this.entity.script.orbitCamera;
    this.distanceMin = 0;
    this.distanceMax = 0;
    this.theSystem = null;
    this.distanceTween = null;
    this.pitchTween = null;
    this.delayTween = null;
    this.waitForPlanets = true;
    this.actualMode = 'planet';
    this.lookTween = null;
    this.firstTime = true;
    this.startSequence = true;
    this.startAutoOrbit = true;
    this.noDistance = false;
    this.startWithUrl= false;
    var url = new URL(window.top.location.href);
    var urlseed = url.searchParams.get('s');

    if(urlseed !== null){
        this.startWithUrl= true;
        this.setMinMax();
        this.autoOrbitDistance = 1200;
        this.startSequence = false;
        this.noDistance = true;
    }   
    
};

CameraController.prototype.resetSeq = function(){
    this.planetCounter = 0;
    this.noDistance = false;
    this.startSequence = false;  
};

CameraController.prototype.haltSequence = function(){
    
    if(!this.startSequence){
        this.startAutoOrbit = false;
        this.noDistance = false;
    }
    
    if(!this.distanceTween){
        return;
    }
    this.firstTime = true;
    this.startAutoOrbit = false;
    this.distanceTween.stop();
    this.pitchTween.stop();
    this.delayTween.stop();
};

CameraController.prototype.startOrbit = function(){
    if(this.app.touch){
        this.haltSequence();
        return;
    }
    
    this.autoOrbitSystems('planet');
    this.startAutoOrbit = true;
};

CameraController.prototype.autoOrbitSystems = function(theMode){

    this.noDistance = false;
   // console.log('yaw: ' + this.orbitCamera.yaw);
    var self = this;
    this.actualMode = theMode;
    
   // console.log('AUTOORBIT BEFORE RETURN');
    if(this.actualMode == 'planet'){
        return;
    }
   // console.log('AUTOORBIT AFTER');

   if(this.noPlanets){
       this.haltSequence();
       this.changePlanet();
   }

   //console.log('noplanets: ' + this.noPlanets + ' planetsLength: ' + this.planets.length + ' planetCounter: ' + this.planetCounter + ' wait: ' + this.waitForPlanets + ' mode: ' + this.actualMode);

    
    if(this.waitForPlanets){
            return;
    }

    this.startAutoOrbit = false;
    
    if(this.planetCounter == this.planets.length){

        this.delayTween.stop();
        
        if(theMode === 'infinity'){
            this.distanceTween.stop();
            this.pitchTween.stop();
            this.waitForPlanets = true;
            this.planetCounter = 0;
            this.planets = [];
            var ps = new pc.Vec3(0,0,0);
            //this.setMinMax();
         //   console.log('called FALSE');
            this.camScript.distanceMin = 1000;
            this.camScript.distanceMax = 2500;

            this.camScript.resetAndLookAtPoint(this.entity.getLocalPosition(), ps, true);
            //console.log('LOADNEWSCENE')
            this.app.fire('hover:generatorTrigger');
            return;
        } else if(theMode === 'system'){
            this.planetCounter = 0;
        }
    }

    if(this.planets.length > 0){
        this.changePlanet();
    }



    this.setMinMax();

    var dst = {value:this.distanceMin};
    this.distanceTween = this.dummy.tween(dst).to({value:this.distanceMax}, 19, pc.SineOut).on('update', function(){
        self.autoOrbitDistance = dst.value;
      //  console.log('dst.dvalue: ' + dst.value);
    }).yoyo(true).loop(true).start();
    
    var ptch = {value:-20};
    this.pitchTween = this.dummy.tween(ptch).to({value:20}, 28, pc.Linear).on('update', function(){
        self.autoOrbitPitch =  ptch.value;
    }).yoyo(true).loop(true).start();  
 

   
    
};

CameraController.prototype.changePlanet = function(){
    //console.log('CHANGEPLANET');
    var that = this;
    if(this.noPlanets){
        this.planets[0] = this.theSystem;
        this.planetCounter = 0;
        this.noPlanets = false;
        this.waitForPlanets = false;
        this.actualMode = 'infinity';
        this.startWithUrl = false;
    }
    
    var pos = this.planets[this.planetCounter].getLocalPosition();
    var tc = this.entity;
    //console.log('changePlanet: ' + this.planets.length);
    this.camScript.resetAndLookAtPoint(tc, pos);
    this.app.fire('userInput:objectSelected', this.planets[this.planetCounter]);
    this.startAutoOrbit = true;
    this.delay(60);
};


CameraController.prototype.delay = function(dl){
    //console.log('DELAY');
    var that = this;
    this.delayTween = this.dummy.tween(this.dummy.getLocalPosition()).to({x:0,y:0,z:0}, dl, pc.Linear).on('complete', function(){
        if(that.startAutoOrbit){
            that.planetCounter++;
            that.autoOrbitSystems(that.actualMode);
        }
    }).start();
};


CameraController.prototype.getPlanets = function(plnts, sn){
    //console.log('GETPLANETS');
   
    this.planets = [sn].concat(plnts);
    if(this.waitForPlanets){
        this.waitForPlanets = false;
        if(!this.startWithUrl){
            this.autoOrbitSystems(this.actualMode);
        } else {
            this.startWithUrl = false;
            this.autoOrbitSystems('planet');
        }
    }   
};

CameraController.prototype.getNumber = function(ent){
    for(var ind = 0; ind < this.planets.length; ind++ ){
        if(this.planets[ind] == ent){
            this.planetCounter = ind;
           // console.log('GETNUMBER: ' + this.planetCounter);
        }
    }
};


CameraController.prototype.setMinMax = function(){

   if(this.planets.length === 0){
       return;
   }
    if(this.planets[this.planetCounter].name === 'system'){
     //   console.log('QUICKLINK:PLANETMINMAX_S');
        this.distanceMin = this.orbitCamera.distanceMin = 1500;
        this.distanceMax = this.orbitCamera.distanceMax = 2500;
    } else if(this.planets[this.planetCounter].name === 'rockPlanet'){
    //    console.log('QUICKLINK:PLANETMINMAX_R');
        this.distanceMin = this.orbitCamera.distanceMin = 150;
        this.distanceMax = this.orbitCamera.distanceMax = 200;
    } else if (this.planets[this.planetCounter].name === 'gasGiant'){
    //    console.log('QUICKLINK:PLANETMINMAX_G');
        this.distanceMin = this.orbitCamera.distanceMin = 350;
        this.distanceMax = this.orbitCamera.distanceMax = 600;
    } else if(this.planets[this.planetCounter].name === 'habitable'){
    //    console.log('QUICKLINK:PLANETMINMAX_H');
        this.distanceMin = this.orbitCamera.distanceMin = 150;
        this.distanceMax = this.orbitCamera.distanceMax = 200;
    }
};


// update code called every frame
CameraController.prototype.update = function(dt) {
    //console.log(this.theSystem);
   // console.log('mode: ' + this.actualMode);
   // this.secsSinceUserInput += dt;
//console.log('yaw: ' + this.orbitCamera.yaw);
    if (this.startAutoOrbit) {
        if(!this.noDistance){
            this.orbitCamera.distance = pc.math.lerp(this.orbitCamera.distance, this.autoOrbitDistance, 0.05);
        }
        
        this.orbitCamera.pitch = pc.math.lerp(this.orbitCamera.pitch, this.autoOrbitPitch, 0.05);
        this.orbitCamera.yaw += this.autoOrbitSpeed * dt;
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// CameraController.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

